import { Box, Button, FortumLogo } from '@fortum/elemental-ui';
import useAdminContext from '@hooks/useAdminContext';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  width: 50%;
`;

function AdminLogin() {
  const { authorizeAdmin, loading, authToken, tokenSet } = useAdminContext(); // Added authToken and tokenSet
  const navigate = useNavigate();
  const { state } = useLocation();

  // MSAL login state
  const [loginError, setLoginError] = useState<string | null>(null);

  // Redirect to dashboard if already logged in
  useEffect(() => {
    if (tokenSet && authToken) {
      // User is already authenticated, redirect to dashboard
      navigate('/admin/dashboard', { replace: true });
    }
  }, [authToken, tokenSet, navigate]);

  async function onLoginClick(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    try {
      const result = await authorizeAdmin();
      if (result) {
        // Redirect after successful login, default to /admin/dashboard if not redirected from another page
        navigate((state as { from?: string })?.from || '/admin/dashboard');
      } else {
        setLoginError('Authentication failed. Please try again.');
      }
    } catch (error) {
      setLoginError('Something went wrong. Please try again later.');
      console.error(error);
    }
  }

  // Show loading indicator while checking authentication
  if (!tokenSet) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <div>Checking authentication status...</div>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding="2rem"
    >
      <FortumLogo />
      <StyledForm onSubmit={onLoginClick}>
        {loginError && (
          <div style={{ color: 'red', marginBottom: '1rem' }}>{loginError}</div>
        )}

        {/* No need for username and password inputs with MSAL */}
        <Button type="submit" color="primary" disabled={loading}>
          {loading ? 'Logging in...' : 'Login with Azure AD'}
        </Button>
      </StyledForm>
    </Box>
  );
}

export default AdminLogin;
